
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import '@/vue_material/components';

import HowToUseModal from '@/components/HowToUseModal.vue';

Vue.component('home-card', HowToUseModal);

@Component({
  components: {
    HowToUseModal,
  },
  props: {
    $data: {
      type: Object,
      required: true,
    },
  },
})

export default class HomeCard extends Vue {
  public $refs!: {
    howToUseModal: any,
  };

  private openCameraConfirmed: boolean = false;

  private canRoute(path: string): Promise<void> {
    return new Promise((resolve: any, reject: any) => {
      const showHowToUseDialog = localStorage.getItem('showHowToUseDialog');

      if (path !== '/camera' || showHowToUseDialog === 'false') {
        resolve();
      } else {
        this.$refs.howToUseModal.open();

        this.openCameraConfirmed ? (resolve()) : (reject());
      }
    });
  }

  @Watch('openCameraConfirmed')
  private route(): void {
    const { path, targetBlank } = this.$data;

    this.canRoute(path).then(() => {
      if (targetBlank) {
        window.open(path, '_blank');
      } else {
        window.history.pushState({}, path, window.location.pathname);

        window.location.replace(path);
      }
    });
  }
}
